import Icon from './Icon';

interface TextInputProps {
  value?: string;
  onChange?: (value: string) => void;
  className?: string;
  placeholder?: string;
}

const SearchInput: React.FC<TextInputProps> = ({ className = '', value = '', onChange = () => {}, placeholder = 'Search' }) => {
  return (
    <div className={`flex items-center gap-[var(--spacing-sm)] rounded-sm bg-input-bg-default px-[var(--spacing-lg)] py-[var(--spacing-md)] ${className}`}>
      <Icon name="chat/search.svg" size={24} />
      <input
        id="search-input"
        name="search-input"
        type="text"
        autoComplete="off"
        maxLength={24}
        className="typography-body-sm flex-1 border-0 bg-transparent text-input-txt-default outline-none placeholder:text-input-txt-placeholder"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') e.currentTarget.blur();
        }}
        placeholder={placeholder}
      />
      {value && <Icon name="chat/cancel-rect.svg" size={24} onClick={() => onChange('')} />}
    </div>
  );
};

export default SearchInput;
